// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"223":"61e93ef32c21059f612f","245":"2bf2fdc581d9729abeef","453":"4d146b310b8f87125b2d","556":"6f2649b518183a0f8914","559":"2d48eafdc629f7fb732e","995":"b5bc1a8e7907d8996f38"}[chunkId] + ".js";
};